export default {"src":"/uk/_next/static/media/limitedCompanyIcon.13d26bb2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};